import { Injectable } from '@angular/core';
import { NavigationAction } from '../model/map-actions/navigation-action';
import { EditorAction } from '../model/map-actions/editor-action';
import { MeasuresAction } from '../model/map-actions/measures-action';
import { InfoAction } from '../model/map-actions/info-action';
import { MapComponent } from '../components/map/map.component';
import { DisplayAction } from '../model/map-actions/display-actions';
import { MapDataAction } from '../model/map-actions/map_data-action';


@Injectable({
	providedIn: 'root'
})
export class ToolService {

	constructor() { }

	DoAction(action: string, map: MapComponent, args?: any) {
		let type: string;
		let func: string;
		if (action.indexOf('/') > -1) {
			const parts = action.split('/');
			type = parts.shift();
			func = parts.join('/');
		} else {
			type = action;
			func = '';
		}
		switch (type) {
			case 'tools':
				break;
			case 'navigation':
				NavigationAction.Exec(func, map, args);
				break;
			case 'info':
				InfoAction.Exec(func, map, args);
				break;
			case 'map data':
				MapDataAction.Exec(func, map, args);
				break;
			case 'editor':
				EditorAction.Exec(func, map, args);
				break;
			case 'measures':
				MeasuresAction.Exec(func, map, args);
				break;
			case 'display':
				DisplayAction.Exec(func, map, args);
				break;
		}
	}
	SetupButtons(map: MapComponent) {
		NavigationAction.SetupButtons(map);
		InfoAction.SetupButtons(map);
		MapDataAction.SetupButtons(map);
		EditorAction.SetupButtons(map);
		MeasuresAction.SetupButtons(map);
		DisplayAction.SetupButtons(map);
	}

}
